/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { classNames } from '@ember-decorators/component';
import { inject as service } from '@ember/service';
import { computed, action } from '@ember/object';
import Editor from 'cio/components/action-composer/base/editor';
import { IdentifierKey } from 'cio/utils/identifiers';
import { CREATED_IN_CIO_AT } from 'cio/utils/attributes';
import { getLiquidToInsert } from 'cio/utils/liquid';

@classNames('action-composer-panel', 'action-composer-panel--editor')
export default class AttributeUpdateEditor extends Editor {
  @service environment;

  @computed('environment.sentAttributes')
  get availableAttributes() {
    return this.environment.sentAttributes.filter((attr) => ![IdentifierKey.CioId, CREATED_IN_CIO_AT].includes(attr));
  }

  @action
  insertLiquid([fieldName], liquid, fallback) {
    let fieldNameToSelector = {
      'model.attributeValue': '.js-editor-textarea',
    };
    let selector = fieldNameToSelector[fieldName];

    if (!selector) {
      return;
    }

    let elem = this.element.querySelector(selector);
    let { selectionStart, selectionEnd, value } = elem;
    let beginStr = value.substr(0, selectionStart);
    let endStr = value.substr(selectionEnd, value.length);
    let liquidToInsert = getLiquidToInsert(liquid, fallback, this.editableEntity.template?.templateEngine);

    elem.value = `${beginStr}${liquidToInsert}${endStr}`;
    elem.dispatchEvent(new Event('input', { bubbles: true }));
  }

  @action
  onChange(selection) {
    return this.editableEntity.action.set('attributeName', selection);
  }
}
